import { IProduct } from "redux/reducers/models/product";

export function applyFolderProductPositionChange(
  products: IProduct[],
  dragId: number,
  targetPosition: number,
): IProduct[] {
  const hasCollision = products.some(
    product => product.id !== dragId && product.folder_position === targetPosition,
  );
  if (!hasCollision) {
    return products.map(product =>
      product.id === dragId ? { ...product, folder_position: targetPosition } : product,
    );
  }
  const dragged = products.find(product => product.id === dragId);
  const other = products.find(
    product => product.id !== dragId && product.folder_position === targetPosition,
  );
  if (
    dragged === undefined ||
    other === undefined ||
    dragged.folder_position === undefined ||
    dragged.folder_position === null
  ) {
    return products;
  }
  const fromPos = dragged.folder_position;
  if (fromPos === targetPosition) {
    return products;
  }
  return products.map(product => {
    if (product.id === dragId) {
      return { ...product, folder_position: targetPosition };
    }
    if (product.id === other.id) {
      return { ...product, folder_position: fromPos };
    }
    return product;
  });
}
